import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import CheckboxListStyles from '@stories/Components/Misc/Forms/Inputs/CheckboxList/CheckboxList.styles';
import styled from 'styled-components';
import { from } from 'stylis';
const Container = styled.section `
  position: relative;
  overflow: hidden;
`;
const Label = styled.p `
  ${fonts.lato.regular};

  font-size: 14px;
  line-height: 24px;
  margin-bottom: ${fluid(12, 18)};
`;
const Options = styled.div `
  display: flex;
  gap: ${fluid(4, 32)};
  overflow: auto;
  left: 0;
  position: relative;

  @media ${from(Device.DesktopSmall)} {
    ${scrollbars};
  }

  ${CheckboxListStyles.Option} {
    flex: 0 0 ${fluid(82, 100)};
  }

  ${CheckboxListStyles.Label} {
    ${transition('background-color, color', 0.25)};

    --bgColour: transparent;
    --textColour: ${brand.global.black};
    --iconColour: ${brand.primary.purple.light};
    --highlightColour: ${brand.primary.blue.light};

    width: 100%;
    display: flex;
    gap: 4px;
    flex-direction: column;
    align-items: center;
    padding: ${fluid(8, 10)} 0 10px;
    height: 100%;
    text-align: center;
    border-radius: 6px 6px 0 0;
    text-transform: uppercase;
    font-weight: 700;
    font-size: ${fluid(12, 14)};
    line-height: ${fluid(14, 20)};
    white-space: normal;
    background-color: var(--bgColour);

    svg {
      ${transition('color', 0.25)};

      display: block;
      width: ${fluid(30, 48, Device.Tablet, Device.Desktop)};
      height: ${fluid(30, 48, Device.Tablet, Device.Desktop)};
      color: var(--iconColour);
    }
  }

  ${CheckboxListStyles.Label}::before {
    display: none;
  }

  ${CheckboxListStyles.Label}::after {
    ${transition('background-size', 0.25)};

    border: 0;
    border-radius: 0;
    left: 0;
    bottom: -2px;
    top: auto;
    left: auto;
    height: 4px;
    width: 100%;
    background-image: linear-gradient(
      to right,
      var(--highlightColour, transparent),
      var(--highlightColour, transparent)
    );
    background-repeat: no-repeat;
    background-size: 0% 100%;
  }

  ${CheckboxListStyles.Input}:checked + ${CheckboxListStyles.Label},
  ${CheckboxListStyles.Option}:has(input:focus-visible), ${CheckboxListStyles.Label}:hover {
    --bgColour: ${brand.primary.purple.light};
    --textColour: ${brand.global.white};
    --iconColour: ${brand.global.white};
  }

  ${CheckboxListStyles.Input}:checked + ${CheckboxListStyles.Label}::after {
    background-size: 100% 100%;
  }
`;
const CommunityFilterStyles = {
    Container,
    Label,
    Options,
};
export default CommunityFilterStyles;
